// extracted by mini-css-extract-plugin
module.exports = {"axis":"yAxis_axis__KHKQY","hide":"yAxis_hide__v5TlY"};